'use strict';

(function () {
    var selectors = {
        root: '[data-association-picker]',
        value: '[data-association-picker-value]',
        search: '[data-association-picker-search]',
        searchPanel: '[data-association-picker-search-panel]',
        status: '[data-association-picker-status]',
        spinner: '[data-association-picker-spinner]',
        results: '[data-association-picker-results]',
        more: '[data-association-picker-more]',
        create: '[data-association-picker-create]',
        selected: '[data-association-picker-selected]',
        selectedName: '[data-association-picker-selected-name]',
        selectedMeta: '[data-association-picker-selected-meta]',
        selectedBadges: '[data-association-picker-selected-badges]',
        change: '[data-association-picker-change]'
    };

    function debounce(callback, delay) {
        var timer = null;
        return function () {
            var args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(null, args);
            }, delay);
        };
    }

    function appendText(parent, tagName, className, value) {
        var element = document.createElement(tagName);
        element.className = className;
        element.textContent = value || '';
        parent.appendChild(element);
        return element;
    }

    function formatDate(value) {
        if (!value) return '';
        var parts = String(value).slice(0, 10).split('-');
        if (parts.length !== 3) return value;
        return parts[2] + '/' + parts[1] + '/' + parts[0];
    }

    function pickerMeta(item, kind) {
        var details = [];
        details.push(item.codice_fiscale ? 'CF ' + item.codice_fiscale : 'Codice fiscale non disponibile');
        if (kind === 'student' && item.nato_il) details.push('Nato/a il ' + formatDate(item.nato_il));
        if (kind === 'teacher' && item.partita_iva) details.push('P. IVA ' + item.partita_iva);
        if (item.email) details.push(item.email);
        return details.join(' · ');
    }

    function addBadge(container, label, style) {
        var badge = appendText(container, 'span', 'label association-result-badge ' + style, label);
        badge.setAttribute('aria-label', label);
    }

    function CourseAssociationPicker(root) {
        this.root = root;
        this.kind = root.getAttribute('data-kind');
        this.searchUrl = root.getAttribute('data-search-url');
        this.minimum = parseInt(root.getAttribute('data-minimum-input-length'), 10) || 3;
        this.contextId = null;
        this.page = 1;
        this.query = '';
        this.request = null;
        this.nodes = {};

        Object.keys(selectors).forEach(function (key) {
            if (key !== 'root') this.nodes[key] = root.querySelector(selectors[key]);
        }, this);

        this.entity = root.querySelector('[data-teacher-entity]');
        this.token = root.querySelector('[data-teacher-lookup-token]');
        this.newFields = root.querySelector('[data-teacher-new-fields]');
        this.notice = root.querySelector('[data-teacher-entity-notice]');
        this.createTeacher = root.querySelector('[data-teacher-create]');
        this.newTeacher = null;
        this.searchDebounced = debounce(this.search.bind(this, false), 280);
        this.bind();
        this.reset();
        root.courseAssociationPicker = this;
    }

    CourseAssociationPicker.prototype.bind = function () {
        var self = this;
        if (this.entity) this.entity.addEventListener('change', function () { self.reset(); });
        if (this.createTeacher) this.createTeacher.addEventListener('click', function () {
            if (!self.newTeacher) return;
            self.select({id: '', full_name: 'Nuova risorsa', codice_fiscale: self.newTeacher.codice_fiscale,
                lookup_token: self.newTeacher.lookup_token, is_new: true,
                entity_notice: 'La nuova anagrafica sarà creata e collegata a ' + self.newTeacher.entity_name + ' al salvataggio.'});
        });
        this.nodes.search.addEventListener('input', function () {
            self.searchDebounced();
        });
        this.nodes.search.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown') {
                var firstResult = self.nodes.results.querySelector('button:not([disabled])');
                if (firstResult) {
                    event.preventDefault();
                    firstResult.focus();
                }
            }
        });
        this.nodes.more.addEventListener('click', function () {
            self.search(true);
        });
        this.nodes.change.addEventListener('click', function () {
            self.clearSelection(true);
        });
    };

    CourseAssociationPicker.prototype.setContext = function (contextId) {
        this.contextId = contextId || null;
        this.reset();
    };

    CourseAssociationPicker.prototype.setStatus = function (message, state) {
        this.nodes.status.textContent = message;
        this.nodes.status.className = 'help-block association-search-status' + (state ? ' is-' + state : '');
    };

    CourseAssociationPicker.prototype.setLoading = function (loading) {
        this.nodes.spinner.classList.toggle('is-visible', loading);
        this.nodes.search.setAttribute('aria-busy', loading ? 'true' : 'false');
    };

    CourseAssociationPicker.prototype.reset = function () {
        if (this.request) this.request.abort();
        this.request = null;
        this.page = 1;
        this.query = '';
        this.nodes.search.value = '';
        this.nodes.results.textContent = '';
        this.nodes.results.hidden = true;
        this.nodes.more.hidden = true;
        this.nodes.create.hidden = true;
        this.setLoading(false);
        this.setStatus('Puoi scrivere anche nome e cognome insieme, in qualsiasi ordine.');
        this.clearSelection(false);
    };

    CourseAssociationPicker.prototype.clearSelection = function (focusSearch) {
        this.nodes.value.value = '';
        if (this.token) this.token.value = '';
        if (this.notice) { this.notice.hidden = true; this.notice.textContent = ''; }
        if (this.newFields) {
            this.newFields.hidden = true;
            this.newFields.querySelectorAll('input').forEach(function (input) { input.disabled = true; input.required = false; input.value = ''; });
        }
        var saveError = this.root.querySelector('[data-teacher-save-error]');
        if (saveError) saveError.hidden = true;
        this.nodes.selected.hidden = true;
        this.nodes.searchPanel.hidden = false;
        this.root.dispatchEvent(new CustomEvent('course-association:cleared', {bubbles: true}));
        if (focusSearch) {
            this.nodes.search.focus();
            if (this.nodes.search.value.trim().length >= this.minimum) this.search(false);
        }
    };

    CourseAssociationPicker.prototype.search = function (append) {
        var self = this;
        var query = this.nodes.search.value.trim().replace(/\s+/g, ' ');
        this.newTeacher = null;
        if (this.createTeacher) this.createTeacher.hidden = true;
        if (this.entity && this.entity.tagName === 'SELECT' && !this.entity.value) {
            this.setStatus('Seleziona prima l’ente del corso.', 'error');
            return;
        }

        if (query.length < this.minimum) {
            if (this.request) this.request.abort();
            this.request = null;
            this.nodes.results.textContent = '';
            this.nodes.results.hidden = true;
            this.nodes.more.hidden = true;
            this.nodes.create.hidden = true;
            this.setLoading(false);
            this.setStatus('Digita almeno ' + this.minimum + ' caratteri per avviare la ricerca.');
            return;
        }

        if (!append || query !== this.query) {
            this.page = 1;
            this.query = query;
            this.nodes.results.textContent = '';
        } else {
            this.page += 1;
        }

        if (this.request) this.request.abort();
        var currentRequest = new AbortController();
        this.request = currentRequest;
        this.nodes.create.hidden = true;
        this.nodes.more.hidden = true;
        this.setLoading(true);
        this.setStatus('Ricerca in corso…');

        var url = new URL(this.searchUrl, window.location.origin);
        url.searchParams.set('search', this.query);
        url.searchParams.set('page', String(this.page));
        if (this.entity && this.entity.value) url.searchParams.set('teacher_entity_id', this.entity.value);
        if (this.contextId) url.searchParams.set('module_id', String(this.contextId));

        fetch(url.toString(), {
            credentials: 'same-origin',
            headers: {'Accept': 'application/json'},
            signal: currentRequest.signal
        }).then(function (response) {
            if (!response.ok) return response.json().then(function (data) { throw new Error(response.status === 429 ? 'Attendi un minuto prima di ripetere la ricerca.' : (data.message || 'Ricerca non riuscita.')); });
            return response.json();
        }).then(function (payload) {
            if (self.request !== currentRequest) return;
            var results = Array.isArray(payload.results) ? payload.results : [];
            self.newTeacher = payload.new_teacher || null;
            if (self.createTeacher) self.createTeacher.hidden = !self.newTeacher;
            self.renderResults(results, append);
            self.nodes.more.hidden = !(payload.pagination && payload.pagination.more);
            self.nodes.create.hidden = results.length !== 0 || append;
            self.setStatus(results.length
                ? 'Seleziona una persona e verifica la scheda riepilogativa.'
                : 'Nessun risultato trovato. Controlla i dati prima di creare una nuova anagrafica.',
                results.length ? 'success' : 'empty');
        }).catch(function (error) {
            if (error.name === 'AbortError') return;
            if (self.request !== currentRequest) return;
            if (append) self.page -= 1;
            self.setStatus(error.message || 'Non è stato possibile completare la ricerca. Riprova.', 'error');
        }).finally(function () {
            if (self.request === currentRequest) {
                self.setLoading(false);
                self.request = null;
            }
        });
    };

    CourseAssociationPicker.prototype.renderResults = function (results, append) {
        var self = this;
        if (!append) this.nodes.results.textContent = '';

        results.forEach(function (item) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'association-result';
            button.setAttribute('role', 'option');
            button.disabled = Boolean(item.disabled);

            var identity = appendText(button, 'span', 'association-result-identity', '');
            appendText(identity, 'strong', '', item.full_name || item.text);
            appendText(identity, 'small', '', pickerMeta(item, self.kind));

            var badges = appendText(button, 'span', 'association-result-badges', '');
            if (self.kind === 'student' && item.active_other_courses_count > 0) {
                addBadge(badges, 'Già associato ad altro corso/percorso', 'label-warning');
            }
            if (self.kind === 'teacher' && item.already_associated_to_module) {
                addBadge(badges, 'Già associato a questo modulo', 'label-default');
            }

            if (!button.disabled) {
                button.addEventListener('click', function () {
                    self.select(item);
                });
            }
            self.nodes.results.appendChild(button);
        });

        this.nodes.results.hidden = this.nodes.results.childElementCount === 0;
    };

    CourseAssociationPicker.prototype.select = function (item) {
        this.nodes.value.value = item.id;
        if (this.token) this.token.value = item.lookup_token || '';
        if (this.notice) { this.notice.textContent = item.entity_notice || ''; this.notice.hidden = !item.entity_notice; }
        if (this.newFields) {
            this.newFields.hidden = !item.is_new;
            this.newFields.querySelectorAll('input').forEach(function (input) { input.disabled = !item.is_new; input.required = Boolean(item.is_new); });
        }
        this.nodes.selectedName.textContent = item.full_name || item.text;
        this.nodes.selectedMeta.textContent = pickerMeta(item, this.kind);
        this.nodes.selectedBadges.textContent = '';

        if (this.kind === 'student' && item.active_other_courses_count > 0) {
            var courseLabel = item.active_other_courses_labels && item.active_other_courses_labels.length
                ? ': ' + item.active_other_courses_labels.join(', ')
                : '';
            addBadge(this.nodes.selectedBadges, 'Già associato' + courseLabel, 'label-warning');
        }

        this.nodes.searchPanel.hidden = true;
        this.nodes.selected.hidden = false;
        this.root.dispatchEvent(new CustomEvent('course-association:selected', {
            bubbles: true,
            detail: {item: item, kind: this.kind}
        }));
    };

    function bindForm(form) {
        var picker = form.querySelector(selectors.root);
        var details = form.querySelector('[data-association-step="details"]');
        var submit = form.querySelector('[data-association-submit]');
        var selectedName = form.querySelector('[data-association-step-selected-name]');
        if (!picker || !details || !submit) return;

        if (picker.getAttribute('data-kind') === 'teacher') {
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                var errorBox = picker.querySelector('[data-teacher-save-error]');
                errorBox.hidden = true;
                if (!picker.querySelector('[data-association-picker-value]').value && !picker.querySelector('[data-teacher-lookup-token]').value) {
                    errorBox.textContent = 'Seleziona un docente o inserisci una nuova risorsa.';
                    errorBox.hidden = false;
                    return;
                }
                if (submit.disabled) return;
                submit.disabled = true;
                fetch(form.action, {method: 'POST', credentials: 'same-origin', headers: {'Accept': 'application/json'}, body: new FormData(form)})
                    .then(function (response) { return response.json().then(function (data) {
                        if (!response.ok) {
                            var messages = data.errors ? Object.keys(data.errors).map(function (key) { return data.errors[key].join(' '); }) : [data.message || 'Salvataggio non riuscito.'];
                            throw new Error(messages.join(' '));
                        }
                        window.location.assign(data.redirect);
                    }); })
                    .catch(function (error) { errorBox.textContent = error.message || 'Salvataggio non riuscito. Riprova.'; errorBox.hidden = false; })
                    .finally(function () { submit.disabled = false; });
            });
        }
        form.addEventListener('course-association:selected', function (event) {
            details.hidden = false;
            if (selectedName) selectedName.textContent = event.detail.item.full_name || event.detail.item.text;
            submit.value = (picker.getAttribute('data-submit-label') || 'Associa') + ' ' +
                (event.detail.item.full_name || event.detail.item.text);
        });
        form.addEventListener('course-association:cleared', function () {
            details.hidden = true;
            if (selectedName) selectedName.textContent = '';
        });
    }

    function init() {
        Array.prototype.forEach.call(document.querySelectorAll(selectors.root), function (root) {
            new CourseAssociationPicker(root);
        });
        Array.prototype.forEach.call(document.querySelectorAll('[data-association-form]'), bindForm);

        if (window.jQuery) {
            window.jQuery('.modal').on('hidden.bs.modal.courseAssociation', function () {
                var form = this.querySelector('[data-association-form]');
                if (!form) return;
                form.reset();
                var picker = form.querySelector(selectors.root);
                if (picker && picker.courseAssociationPicker) picker.courseAssociationPicker.reset();
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
